import React, { useState } from "react";
import "../style.scss";
import DeleteDeactivateAcc from "../modals/DeleteDeactivateAcc";
import AccountManagementActions from "./AccountManagementActions";

const actions = [
   {
      actionTitle: "Deactivate account",
      actionType:
         "You can deactivate your account here. This will make your account temporarily unusable. However, this action is fully reversible, and",
      actionExplanation: "you can reactivate your account at any time by simply logging back in.",
      actionButton: "Deactivate account",
      showModalType: "deactivate"
   },
   {
      actionTitle: "Delete account",
      actionType: "Deleting your account will permanently remove all your data from our system.",
      actionExplanation:
         "This action is irreversible, meaning once your account is deleted, you will not be able to recover any of your information or content.",
      actionExplanation2: "If you are certain you want to proceed, ",
      actionExplanation3:
         "please be aware that you will lose access to all services and data associated with your account.",
      actionButton: "Delete account",
      showModalType: "delete"
   }
];

const AccountManagement = () => {
   const [open, setOpen] = useState(false);
   const [action, setAction] = useState("");

   const showModal = (type) => {
      setAction(type);
      setOpen(true);
   };

   const onClose = () => {
      setOpen(false);
   };

   const props = {
      open,
      onCancel: onClose,
      setOpen,
      title: action === "delete" ? "Delete your  account" : "Deactivate your account",
      description:
         action === "delete"
            ? "Oh, we're sorry to see you go, but respect your decision! "
            : "Thinking of taking a break? Deactivating your account is always an option. ",
      buttonText: action === "delete" ? "Delete account" : "Deactivate account",
      confirmationTitle:
         action === "delete" ? "Confirm account deletion" : "Confirm account deactivation"
   };

   return (
      <div className="accountManagementContainer">
         <div className="d-flex flex-column">
            <span className="title-heading">Account management</span>
            {actions.map((actionItem, index) => (
               <div key={actionItem.showModalType}>
                  <AccountManagementActions {...actionItem} showModal={showModal} />
                  {index === 0 && (
                     <div style={{ padding: "40px 0" }}>
                        <span className="horizontal-line"></span>
                     </div>
                  )}
               </div>
            ))}
         </div>
         <DeleteDeactivateAcc {...props} action={action} />
      </div>
   );
};
export default AccountManagement;
